import clsx from 'clsx';
import React from 'react';

interface BillingPortalLinkProps {
    label: string;
    onClick: () => void;
    disabled?: boolean;
}

const BillingPortalLink: React.FC<BillingPortalLinkProps> = ({
    label,
    onClick,
    disabled = false,
}) => (
    <div className="mx-auto mt-5 flex w-full max-w-[820px] justify-center px-0.5">
        <button
            type="button"
            onClick={onClick}
            disabled={disabled}
            className={clsx(
                'text-sm text-text-sub underline transition-colors hover:text-text-main focus-visible:outline-none',
                disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer',
            )}
        >
            {label}
        </button>
    </div>
);

export default BillingPortalLink;
